'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodashObjectAssign = require('lodash/object/assign');

var _lodashObjectAssign2 = _interopRequireDefault(_lodashObjectAssign);

var styles = {
  ul: {
    position: 'absolute',
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    pointerEvents: 'none'
  },
  li: {
    textAlign: 'left',
    fontFamily: '\'Helvetica Neue\', Helvetica, Arial, sans-serif',
    fontSize: '14px',
    padding: '0 3px',
    cursor: 'pointer',
    color: '#000',
    backgroundColor: 'rgba(222,232,222,.785)'
  }
};

var CursorHintDesign = (function (_React$Component) {
  _inherits(CursorHintDesign, _React$Component);

  function CursorHintDesign() {
    _classCallCheck(this, CursorHintDesign);

    _get(Object.getPrototypeOf(CursorHintDesign.prototype), 'constructor', this).apply(this, arguments);
  }

  _createClass(CursorHintDesign, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var hint = _props.hint;
      var x = _props.x;
      var y = _props.y;

      var ulStyle = (0, _lodashObjectAssign2['default'])({
        left: x,
        top: y
      }, styles.ul);

      return _react2['default'].createElement(
        'ul',
        { style: ulStyle },
        hint.map(function (line, idx) {
          return _react2['default'].createElement(
            'li',
            { style: styles.li, key: idx },
            line
          );
        })
      );
    }
  }]);

  return CursorHintDesign;
})(_react2['default'].Component);

exports['default'] = CursorHintDesign;
module.exports = exports['default'];
//# sourceMappingURL=CursorHintDesign.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/transhand/lib/cursorHint/CursorHintDesign.js
 ** module id = 3289
 ** module chunks = 0
 **/